import React, {useEffect, useState} from 'react';
import './InsuranceAgentForm.scss';
import DynaButton from "../../DynaView/DynaButton";
import {useLocation, useNavigate} from "react-router-dom";
import _axios from "../../../../httpService";
import {prefixUrl} from "../../../../utils/utilsData";
import {toast} from "react-toastify";
import Loader from "../../../Loader";
import DynaInput from "../../DynaView/DynaInput";
import DynaSelectBox from "../../DynaView/DynaSelectBox";

const InsuranceAgentForm = () => {

  const navigateTo = useNavigate();
  const myLocation = useLocation();
  const [initialData, setInitialData] = useState([]);
  const [insuranceTypeSub, setInsuranceTypeSub] = useState([]);
  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    fullName: "",
    nationalId: "",
    mobile: "",
    percent: "",
    insuranceTypeId: "",
    insuranceTypeSubId: ""
  })

  useEffect(() => {
    _axios.get(prefixUrl() + `/insurance/?request=insuranceType`).then((response) => {
      if (response.data.status) {
        setInitialData(response?.data?.data)
        if (myLocation?.state?.id) {
          _axios.get(prefixUrl() + `/insurance/?request=agentSubmittedData&agentId=${myLocation?.state?.id}`).then((editData) => {
            if (editData?.data?.status) {
              setSendData({...sendData, ...editData.data?.data, agentId: myLocation?.state?.id})
              const subList = response?.data?.data.filter((item) => item.value === editData.data?.data?.insuranceTypeId)
              if (subList.length > 0) {
                setInsuranceTypeSub(subList[0].subGroups)
              } else {
                setInsuranceTypeSub([])
              }
              setIsLoad(true)
            } else {
              toast.error(response.data?.message)
            }
          })
        } else {
          setIsLoad(true)
        }
      } else {
        toast.error(response.data?.message)
      }
    })
  }, []);

  const formDataHandler = async () => {
    if (sendData?.fullName === "") {
      return toast.error("نام و نام خانوادگی را وارد کنید")
    }
    if (sendData?.nationalId.length !== 10) {
      return toast.error("کد ملی را به درستی وارد کنید")
    }
    if (sendData?.mobile.length !== 11) {
      return toast.error("شماره موبایل را به درستی وارد کنید")
    }
    if (sendData?.insuranceTypeId === "") {
      return toast.error("نوع بیمه را انتخاب کنید کنید")
    }
    if (sendData?.percent === "") {
      return toast.error("درصد بازاریاب را انتخاب کنید کنید")
    }

    const Data = {
      request: myLocation?.state?.id ? "agentEdit" : "agentSubmit",
      data: {
        ...sendData
      }
    }
    const response = await _axios.post(prefixUrl() + "/insurance/", Data);
    if (response.data.status) {
      toast.success(response.data?.message)
      navigateTo(-1)
    } else {
      toast.error(response.data?.message)
    }

  }

  try {
    return (
      <section className="insurance-agent-form">
        {isLoad ? <>
          <div className={"form-side"}>

            <DynaInput label={"نام و نام خانوادگی"}
                       name={"fullName"}
                       className={"solid-dyna-input"}
                       placeholder={"نام و نام خانوادگی را وارد کنید"}
                       value={sendData?.fullName}
                       type={"text"}
                       setDataFromComponent={(data) => {
                         setSendData({...sendData, ...data})
                       }}
            />

            <DynaInput label={`کد ملی`}
                       name={"nationalId"}
                       className={"solid-dyna-input"}
                       placeholder={`کد ملی را وارد کنید`}
                       value={sendData?.nationalId}
                       type={"number"}
                       setDataFromComponent={(data) => {
                         if (data.nationalId.length < 11) {
                           setSendData({...sendData, ...data})
                         }
                       }}
            />

            <DynaInput label={"شماره موبایل"}
                       name={"mobile"}
                       className={"solid-dyna-input"}
                       placeholder={"شماره موبایل را وارد کنید"}
                       value={sendData?.mobile}
                       type={"number"}
                       setDataFromComponent={(data) => setSendData({...sendData, ...data})}
            />

            <DynaSelectBox options={initialData}
                           hasFilter={true}
                           label={"نوع بیمه"}
                           className={"solid-dyna-input"}
                           value={sendData?.insuranceTypeId}
                           onChange={(data) => {
                             setInsuranceTypeSub(data?.subGroups)
                             if (data?.subGroups.length > 0) {
                               setSendData({
                                 ...sendData,
                                 insuranceTypeId: data.value,
                                 insuranceTypeSubId: data?.subGroups[0].value
                               })
                             } else {
                               setSendData({...sendData, insuranceTypeId: data.value, insuranceTypeSubId: ""})
                             }
                           }}
            />

            <div className={"row-two-column"}>
              <DynaSelectBox options={insuranceTypeSub}
                             hasFilter={false}
                             label={"زیرگروه"}
                             className={"solid-dyna-input"}
                             value={sendData?.insuranceTypeSubId}
                             onChange={(data) => setSendData({...sendData, insuranceTypeSubId: data.value})}
              />

              <DynaInput label={`درصد بازاریاب`}
                         name={"percent"}
                         className={"solid-dyna-input"}
                         placeholder={`درصد بازاریاب را وارد کنید`}
                         value={sendData?.percent}
                         type={"number"}
                         setDataFromComponent={(data) => {
                           if (+data.percent < 101) {
                             setSendData({...sendData, ...data})
                           }
                         }}
              />
            </div>

            <div className={"button-side"}>
              <DynaButton className={"insurance-button-cansel"}
                          type={"button"}
                          onClick={() => navigateTo(-1)}>انصراف</DynaButton>
              <DynaButton className={"insurance-button"}
                          type={"button"}
                          onClick={formDataHandler}>ثبت</DynaButton>
            </div>
          </div>
        </> : <Loader/>}
      </section>
    );
  } catch (e) {
    return <>{e.toLocaleString()}</>
  }
};

export default InsuranceAgentForm;